<template>
	<van-popup v-model="showPicker" position="bottom">
		<van-picker ref="picker" show-toolbar cancel-button-text="klar" confirm-button-text="Sicher" :columns="columns"
			:item-height="34" @cancel="showPicker = false" @confirm="onConfirm" />
	</van-popup>
</template>

<script>
	const LANGUAGE_OPTIONS = [{
		code: 'de',
		label: 'Deutsch'
	}, {
		code: 'pt',
		label: 'Portugues'
	}, {
		code: 'fr',
		label: 'Francais'
	}, {
		code: 'ga',
		label: 'Gaeilge'
	}];

	export default {
		name: 'LanguagePicker',
		data() {
			return {
				showPicker: false,
				columns: LANGUAGE_OPTIONS.map(item => item.label),
				languageOptions: LANGUAGE_OPTIONS,
			};
		},
		methods: {
			getLangLabel(code) {
				const matched = this.languageOptions.find(item => item.code === code);
				return matched ? matched.label : this.languageOptions[0].label;
			},
			getLangCode(label) {
				const matched = this.languageOptions.find(item => item.label === label);
				return matched ? matched.code : this.languageOptions[0].code;
			},
			open() {
				this.showPicker = true;
				this.$nextTick(() => {
					const currentCode = localStorage.getItem('lang') || this.languageOptions[0].code;
					const currentIndex = this.languageOptions.findIndex(item => item.code === currentCode);
					if (this.$refs.picker && this.$refs.picker.setColumnIndex) {
						this.$refs.picker.setColumnIndex(0, currentIndex > -1 ? currentIndex : 0);
					}
				});
			},
			onConfirm(value) {
				const code = this.getLangCode(value);
				const payload = {
					code,
					label: value
				};

				localStorage.setItem('lang', code);
				if (this.$i18n) {
					this.$i18n.locale = code;
				}

				this.$emit('input', code);
				this.$emit('change', payload);
				this.showPicker = false;
			},
		},
	};
</script>

<style lang='less' scoped>
	::v-deep .van-picker__toolbar {
		position: relative;
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 46px;
		padding: 0 20px;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		font-size: 15px;
		background-color: #fff;
	}

	::v-deep .van-picker__cancel {
		color: #aaa;
	}

	::v-deep .van-picker__confirm {
		color: #01beff;
	}

	::v-deep .van-picker__columns {
		height: 260px !important;
	}
</style>
